jQuery(function ($) {
  // $('a[href*="#"]').on("click", function (e) {
  //   e.preventDefault();
  //   var extraOffset = 100;
  //   $("html, body").animate(
  //     {
  //       scrollTop: $($(this).attr("href")).offset().top - extraOffset,
  //     },
  //     800,
  //     "linear"
  //   );
  // });
  // $(window).load(function () {

  // });
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // if (scroll >= 250) {
    //     $("header a.btn--primary").addClass("show");
    //     $("header .btn--secondary").addClass("hide");
    // } else {
    //     $("header a.btn--primary").removeClass("show");
    //     $("header .btn--secondary").removeClass("hide");
    // }

    if (scroll >= 90) {
      $('header.dark').addClass('active');
    } else {
      $('header.dark').removeClass('active');
    }
  });
  $('.hamburger').click(function () {
    $('.mobile-nav').addClass('show').removeClass('hide');
  });
  $('.close-button').click(function () {
    $('.mobile-nav').addClass('hide').removeClass('show');
  });
  $('li.menu-item-has-children').click(function () {
    $(this).children('.sub-menu').toggleClass('show');
  });

  window.addEventListener('scroll', function () {
    var scroll = window.scrollY;
    if (scroll >= 15) {
      $('header').addClass('active');
    } else {
      $('header').removeClass('active');
    }
  });
});
